import axios from 'axios'
import hostConf from '$config/frontend'
import { showNetworkErrorSnackbar } from '$comp/snackbars'
import { getAuthToken } from '$logic/auth'

export const postApi = action =>
  axios
    .post(
      `${hostConf.HTTP_HOST}/api`,
      { action: JSON.stringify(action) },
      {
        headers: {
          ...(getAuthToken() ? { 'X-Auth-Token': getAuthToken() } : null),
        },
      },
    )
    .then(res => res.data)

export const httpRequest = async action => {
  const response = await postApi(action).catch(() => {
    showNetworkErrorSnackbar()
    return false
  })

  return response || false
}
